import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'react-bootstrap';

class CatchNews extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    let marqueeSpeed = 20;
    let config = this.props.catchAnnouncementsConfig.filter((config)=> config.key == 'CATCH_NEWS_TEXT_ROTATE_SPEED');
    if(config.length > 0) {
      marqueeSpeed = config[0].value;
    }
    const catchNews = this.props.catchNews.sort((a, b) => parseInt(a.sort_order) - parseInt(b.sort_order));
    const catchNewsList = [];
    catchNews.forEach((news)=>{
      catchNewsList.push((<p>{news.news}<br/><br/></p>));
    })
    if(!catchNewsList.length) {
      marqueeSpeed = 0;
    }

    return (
      <div className="row cath-news-section">
        <div className="col-md-12">
          <h4>
            Catch News:
          </h4>
          <div className="catch-news-list">
            <div className="scrolling" style={{animation: `marquee ${marqueeSpeed}s linear infinite`}}>
            {catchNewsList.length ? catchNewsList : <p id='catchNewsInfo'>No catch news found...</p>}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
CatchNews.propTypes = {
};
export default CatchNews;



// WEBPACK FOOTER //
// src/routes/home/components/CatchNews.js